// File Metadata:
// Filename: LoginButton.jsx
// Version: 1.00
// Created: 2026-06-14
// Last Modified: 2026-06-14
// Authors: GitHub Copilot
// Description: Login button component for displaying when user is not authenticated

import React from 'react';
import { Chip, Link } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const LoginButton = () => {
  const theme = useTheme();

  return (
    <Chip
      label="Log in"
      component={Link}
      to="/login"
      clickable
      sx={{
        fontWeight: 600,
        fontSize: '0.85rem',
        bgcolor: alpha(theme.palette.primary.main, 0.12),
        color: theme.palette.primary.main,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
        '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.2) },
      }}
    />
  );
};

export default LoginButton;
